import AddNewProductDetail from "./AddNewProductDetail";
export default AddNewProductDetail